<template>
    <div>
        <div class='login-container'>
            <div class='input-area'>
                <input v-model.trim='uid'
                       :disabled='isDisableInput'
                       autofocus
                       placeholder='아이디 (이메일)'
                       type='text'
                       @touchstart.self='testMethod($event)'
                       @keyup.enter='onClickInquiry' />
                <input v-model.trim='password'
                       :disabled='isDisableInput'
                       placeholder='비밀번호'
                       type='password'
                       @touchstart.self='testMethod($event)'
                       @keyup.enter='onClickInquiry' />
            </div>
            <div class='select-area'>
                <select v-if='centerList.length > 0' v-model='centerId' @change='onUpdateCenter'>
                    <option value=''>센터선택</option>
                    <option v-for='(c, index) in centerList' :key='index' :value='c.id'>{{ c.centerName }}</option>
                </select>
            </div>
            <div class='com-check'>
                <input id='check-all' v-model='isSaveId' name='check-all' type='checkbox'>
                <label for='check-all'>아이디 저장</label>
            </div>
            <div class='com-check'>
                <input id='autoLogin' v-model='isAutoLogin' name='autoLogin' type='checkbox'>
                <label for='autoLogin'>로그인 상태유지</label>
                <!--
                <div class='com-tooltip'>
                    <button class='icon'></button>
                    <div class='detail'>
                        <span class='tit'>자동로그인</span>
                        <p class='txt'>
                            개인정보 보호를 위해 개인기기에서만 사용해 주세요.
                        </p>
                    </div>
                </div>
                -->
            </div>
            <div class='btn-area'>
                <button :disabled='isDisableInput' @click='onClickInquiry'>로그인</button>
            </div>
            <!--
            <div class='btn-area half'>
                <button @click='layerCenter = true'>센터등록</button>
                <button @click='layerPassword = true'>비밀번호 찾기</button>
            </div>
            -->
            <p @click='layerPassword = true' class='bottom-txt'>비밀번호 재설정</p>
            <p class='bottom-txt2'>핏투데이가 처음이라면 <span @click='layerCenter = true' >소속된 센터 인증하기</span></p>
        </div>

        <!-- 센터등록 팝업 -->
        <div v-show='layerCenter' class='layer-pop square-type login-type'>
            <div class='view-content'>
                <button class='close' @click='handleCancel("layerCenter")'><span class='blind'>레이어 닫기</span></button>
                <div class='login-area'>
                    <span class='title'>센터 인증하기</span>
                    <p class='info-txt'>근무중인 센터 운영자에게 안내 받은 이메일과<br>직원인증번호를 입력하세요.</p>
                    <div class='input-line'>
                        <span class='tit'>이메일 주소</span>
                        <input v-model='registCenterDlg.email' type='email'>
                    </div>
                    <div class='input-line'>
                        <span class='tit'>직원인증번호</span>
                        <input v-model='registCenterDlg.staffAuthNumber' type='text'>
                    </div>
                    <p class="bottom-txt" @click="handleStaffAuth">직원인증번호 찾기</p>
                    <div class='bottom-btn' style="margin-top: 36px">
                        <button @click='handleCancel("layerCenter")'>취소</button>
                        <button @click='staffAuthNumber'>다음</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 센터등록 비밀번호설정 팝업 -->
        <div v-show='layerCenterPassword' class='layer-pop square-type login-type'>
            <div class='view-content'>
                <button class='close' @click='handleCancel("layerCenterPassword")'><span class='blind'>레이어 닫기</span></button>
                <div class='login-area'>
                    <span class='title'>비밀번호 설정</span>
                    <div class='input-line'>
                        <span class='tit'>새로운 비밀번호</span>
                        <input v-model='newPassword' type='password'>
                        <p class='txt'>영문, 숫자 포함한 8글자 이상 입력해주세요</p>
                    </div>
                    <div class='input-line'>
                        <span class='tit'>비밀번호 확인</span>
                        <input v-model='retypePassword' type='password'>
                    </div>
                    <div class='bottom-btn'>
                        <button @click='handleCancel("layerCenterPassword")'>취소</button>
                        <button @click='createPassword'>확인</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 비밀번호 재설정 팝업 -->
        <div v-show='layerPassword' class='layer-pop square-type login-type'>
            <div class='view-content'>
                <button class='close' @click='handleCancel("layerPassword")'><span class='blind'>레이어 닫기</span></button>
                <div class='login-area'>
                    <span class='title'>비밀번호 설정</span>
                    <p class='info-txt'>비밀번호 변경하시려면 이메일 인증을 진행 해 주세요.</p>
                    <div class='input-line'>
                        <span class='tit'>이메일 주소</span>
                        <input v-model='registCenterDlg.email' type='email'>
                    </div>
                    <div class='input-line'>
                        <span class='tit'>직원인증번호</span>
                        <input v-model='registCenterDlg.staffAuthNumber' type='text'>
                    </div>
                    <p class="bottom-txt" @click="handleStaffAuth">직원인증번호 찾기</p>
                    <div class='bottom-btn' style="margin-top: 36px">
                        <button @click='handleCancel("layerPassword")'>취소</button>
                        <button @click='passwordEmailCertify'>다음</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 비밀번호 재설정(인증코드) 팝업 -->
        <div v-show='layerPasswordCode' class='layer-pop square-type login-type'>
            <div class='view-content'>
                <button class='close' @click='handleCancel("layerPasswordCode")'><span class='blind'>레이어 닫기</span></button>
                <div class='login-area'>
                    <span class='title'>비밀번호 재설정</span>
                    <p class='info-txt'>
                    </p>
                    <div class='input-line'>
                        <span class='tit'>새로운 비밀번호</span>
                        <input v-model='newPassword' type='password'>
                    </div>
                    <div class='input-line'>
                        <span class='tit'>비밀번호 확인</span>
                        <input v-model='retypePassword' type='password'>
                    </div>
                    <div class='bottom-btn'>
                        <button @click='handleCancel("layerPasswordCode")'>취소</button>
                        <button @click='resetPassword'>완료</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 직원인증번호 찾기 -->
        <div v-show='layerStaffAuth' class='layer-pop square-type login-type'>
            <div class='view-content'>
                <button class='close' @click='handleCancel("layerStaffAuth")'><span class='blind'>레이어 닫기</span></button>
                <div class='login-area'>
                    <span class='title'>직원인증번호 찾기</span>
                    <p class='info-txt'>소속된 센터에 등록된 정보를 입력해 주세요.</p>
                    <div class='input-line'>
                        <span class='tit'>이름</span>
                        <input v-model='staffAuthDlg.name' type='text'>
                    </div>
                    <div class='input-line'>
                        <span class='tit'>핸드폰번호</span>
                        <input v-model='staffAuthDlg.phone' type='text'>
                    </div>
                    <div class='input-line'>
                        <span class='tit'>이메일 주소</span>
                        <input v-model='staffAuthDlg.email' type='email'>
                    </div>
                    <div class='bottom-btn'>
                        <button @click='handleCancel("layerStaffAuth")'>취소</button>
                        <button @click='onFindStaffAuth'>확인</button>
                    </div>
                    <!-- <div v-show='registCenterDlg.isShowEmailField' class='input-line'>
                        <span class='tit'>인증코드 입력</span>
                        <div class='code-item'>
                            <input v-model='registCenterDlg.emailAuthNumber' type='text'>
                            <button @click='emailAuthNumber'>재발송</button>
                        </div>
                        <p class='txt'>이메일로 발송된 인증코드 6자리를 입력하세요.</p>
                    </div> -->
                    <!-- <div v-show='registCenterDlg.isShowEmailField' class='bottom-btn'>
                        <button @click='certifyEmail'>확인</button>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import { getAuth, createUserWithEmailAndPassword, sendEmailVerification, signInWithEmailAndPassword } from "firebase/auth";
import { Utils } from '@/assets/js/utils';

export default {
    name: 'adminLogin',
    props: {},
    computed: {
        isDisableInput() {
            return (this.authStep !== 1);
        },
    },
    data() {
        return {
            authStep: 1,
            centerList: [],
            cid: '',
            uid: '', // notbad@notbad.com
            password: '', // 1234
            errorMessage: '',
            centerId: '',
            isSaveId: false,
            isAutoLogin: false,
            layerCenter: false, // 센터등록 레이어 팝업
            layerCenterPassword: false, // 센터등록 비밀번호 레이어 팝업
            layerPassword: false, // 비밀번호 재설정 레이어 팝업
            layerPasswordCode: false, // 비밀번호 재설정 인증코드 레이어 팝업
            layerStaffAuth: false,   // 직원인증번호 찾기

            registCenterDlg: {
                email: '',
                staffAuthNumber: '',
                emailAuthNumber: '',
                isShowEmailField: false,
            },

            resetPasswordDlg: {
                password: '',
                retypePassword: '',
            },

            staffAuthDlg: {
                name: '',
                phone: '',
                email: '',
            },
            loginCenterId: '',
            loginStaffId: '',
            newPassword: '',
            retypePassword: '',
            tick: undefined,
        };
    },
    mounted() {
        this.isAutoLogin = window.localStorage.getItem('isAutoLogin');
        // 자동로그인 true면 홈화면으로 이동
        if(this.$store.state.auth.user && this.isAutoLogin) {
            this.$router.push({ name: 'CenterMain' });
            return;
        }

        // 세션 만기시, 로그인 페이지 이동되면, 전체 세션관련 캐시 버리기 > 자동로그인 도입으로 주석처리(장지현_20220129)
        /*
        if (auth.state.user) {
            api.delete(`/admin/api/auth/${auth.state.user.refreshToken}`);
            localStorage.removeItem('userInfo');
            localStorage.removeItem('userMenu');
            localStorage.removeItem('menuEventCds');
        }
        */

        // 로컬 스토리지에 저장된 아이디 가져오기
        this.uid = window.localStorage.getItem('uid');
        this.isSaveId = !(this.uid === '' || this.uid === null);

        // 로컬 스토리지에 저장된 자동로그인 여부 가져오기
        this.isAutoLogin = !(this.isAutoLogin === '' || this.isAutoLogin === null);
    },
    methods: {
        onUpdateCenter() {
            if (Utils.isEmpty(this.centerId)) {
                return false;
            }
            if (!Utils.isEmpty(this.centerId)) {
                this.signup(this.uid, this.password, this.centerId);
            }
        },
        onClickInquiry() {
            this.authStep = 2;
            this.inquiry();

            // 아이디를 로컬 스토리지에 저장하는 부분
            if (this.isSaveId) {
                window.localStorage.setItem('uid', this.uid);
            } else {
                window.localStorage.removeItem('uid');
            }

            // 자동로그인 여부를 로컬 스토리지에 저장하는 부분
            if (this.isAutoLogin) {
                window.localStorage.setItem('isAutoLogin', this.isAutoLogin);
            } else {
                window.localStorage.removeItem('isAutoLogin');
            }
        },
        async inquiry() {
            try {
                const { data } = await this.sendPostStaffInquiry();
                if (data.length > 1) {
                    // 센터가 하나 이상
                    this.centerList = data;
                } else if (data.length === 1) {
                    // 센터가 하나
                    const centerId = data[0].id;
                    this.signup(this.uid, this.password, centerId);
                } else {
                    // 센터가 없는 경우 (비정상)
                    this.authStep = 1;
                    alert('로그인 정보를 확인하세요.');
                }
            } catch (e) {
                console.log('e', e);
                if (!e.response.data.message) {
                    alert('오류가 발생했습니다.');
                }else {
                    alert(e.response.data.message)
                }
                this.authStep = 1;
            }
        },
        signup(username, password, centerId) {
            const type = 'D'; // 센터직원:D, 케어관리자:S

            if (!username || !password || !type) {
                this.errorMessage = '로그인 정보를 입력하세요.';
                return false;
            }

            this.$store
                .dispatch('auth/login', {
                    username, password, type, centerId,
                })
                .then(() => {
                    this.$store.commit('auth/setCenters', this.centerList)
                    this.$router.push({ name: 'CenterMain' });
                })
                .catch(({ message }) => {
                    if (message === '사용불가한 센터의 직원입니다.') {
                        alert('사용기간이 종료되어 사용이 불가합니다.\n핏투데이케어로 문의 해 주세요.');
                    }
                    this.errorMessage = message;
                    this.authStep = 1;
                });
        },
        async sendPostStaffInquiry() {
            return api.post('/admin/api/auth/staff/inquiry', {
                username: this.uid,
                password: this.password,
            });
        },
        handleCancel(layer) {
            // 비밀번호 재설정 인증
            if (layer === 'layerPassword') {
                this.layerPassword = false;

                this.registCenterDlg.email = '';
                this.registCenterDlg.staffAuthNumber = '';

                return;
            }

            // 센터 인증하기
            if (layer === 'layerCenter') {
                this.layerCenter = false;

                this.registCenterDlg.email = '';
                this.registCenterDlg.staffAuthNumber = '';

                return;
            }

            // 비밀번호 재설정
            if (layer === 'layerPasswordCode') {
                this.layerPasswordCode = false;

                this.newPassword = '';
                this.retypePassword = '';

                return;
            }

            // 비밀번호 설정
            if (layer === 'layerCenterPassword') {
                this.layerCenterPassword = false;

                this.newPassword = '';
                this.retypePassword = '';

                return;
            }

            // 직원인증번호 찾기
            if (layer === 'layerStaffAuth') {
                this.layerStaffAuth = false;

                this.staffAuthDlg = {
                    name: '',
                    phone: '',
                    email: '',
                }

                return;
            }
        },
        // 센터직원 직원번호 인증, 성공시 메일로 이메일인증번호 전
        async staffAuthNumber() {
            try {
                const { data } = await this.getStaffAuthNumber();

                this.loginCenterId = data.centerId; // 받은 데이터의 센터값 설정
                this.loginStaffId = data.centerStaffId; // 받은 데이터의 스태프 아이디 값 설정

                this.layerCenterPassword = true; // 센터등록 패스워드창 띄우기
            } catch (error) {
                console.log(error);
                alert('이메일 주소 또는 직원인증번호가 다릅니다.');
            }
        },
        // API
        getStaffAuthNumber() {
            return api.put('/admin/api/auth/staff/certify/staffAuthNumber', {
                email: this.registCenterDlg.email, // 'rabbitistokki@gmail.com',
                staffAuthNumber: this.registCenterDlg.staffAuthNumber, // '3110',
            });
        },
        // 센터직원 이메일인증번호 요청
        async emailAuthNumber() {
            try {
                const { data } = await this.getEmailAuthNumber();
                console.log('인증번호', data);
            } catch (error) {
                console.log(error);
            }
        },
        // API
        getEmailAuthNumber() {
            return api.put('/admin/api/auth/staff/request/emailAuthNumber', {
                email: this.registCenterDlg.email,
            });
        },
        // 센터직원 이메일인증번호 인증
        async certifyEmail() {
            try {
                const { data } = await this.getCertifyEmail();
                console.log('dad', data);
                this.layerCenterPassword = true;
            } catch (error) {
                alert('인증번호를 확인해주세요.');
                console.log(error);
                console.log('error');
            }
        },
        // api
        getCertifyEmail() {
            return api.put('/admin/api/auth/staff/certify/email', {
                centerId: this.loginCenterId,
                centerStaffId: this.loginStaffId,
                emailAuthNumber: this.registCenterDlg.emailAuthNumber, // String
            });
        },
        // 센터직원 비밀번호 설정
        async createPassword() {
            try {
                const validate = this.validatePasswordValues();
                if (!validate.result) {
                    alert(validate.msg);
                    return;
                }
                const { data } = await this.getResetPassword();

                alert('센터 등록 완료 되었습니다. 로그인 해 주세요.');

                this.handleCancel("layerCenterPassword");
                this.handleCancel("layerCenter");
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        // 센터직원 비밀번호 설정
        async resetPassword() {
            try {
                const validate = this.validatePasswordValues();
                if (!validate.result) {
                    alert(validate.msg);
                    return;
                }
                const { data } = await this.getResetPassword();

                alert('비밀번호 변경이 완료 되었습니다.');

                this.handleCancel("layerPasswordCode");
                this.handleCancel("layerPassword");
            } catch (error) {
                console.log(error.message);
                console.log('error');
                // alert(error.message);
            }
        },
        getResetPassword() {
            return api.put('/admin/api/auth/staff/reset/password', {
                centerId: this.loginCenterId,
                centerStaffId: this.loginStaffId,
                email: this.registCenterDlg.email,
                // emailAuthNumber: this.registCenterDlg.emailAuthNumber,
                // oldPassword: this.resetPasswordDlg.password, 사용하지않으면 새로 등록
                password: this.newPassword
            });
        },
        // 비밀번호 validation
        validatePasswordValues() {
            // 필수값 체크
            let result = false;
            let msg = '';
            const chk_num = this.newPassword.search(/[0-9]/g);
            const chk_eng = this.newPassword.search(/[a-z]/ig);

            // 미입력
            if (this.newPassword.trim() === '' || this.retypePassword.trim() === '') {
                msg = '비밀번호를 입력하세요.';
                return { result, msg };
            }
            // 길이 체크
            if (this.newPassword.trim().length < 8) {
                msg = '영문, 숫자 포함한 8글자 이상 입력해주세요';
                return { result, msg };
            }
            // 일치 여부
            if (this.newPassword !== this.retypePassword) {
                msg = '새로운 비밀번호와 확인 비밀번호가 다릅니다.';
                return { result, msg };
            }
            // 숫자 영문 포함 여부 확인
            if (chk_num < 0 || chk_eng < 0) {
                msg = '비밀번호는 숫자와 영문자를 포함하여야 합니다.';
                return { result, msg };
            }
            // if (this.registCenterDlg.emailAuthNumber.trim() === '') {
            //     msg = '인증코드를 입력하세요';
            //     return { result, msg };
            // }

            result = true;
            return { result };
        },
        // 비밀번호 변경을 위한
        async passwordEmailCertify() {
            try {
                const { data } = await this.getStaffAuthNumber();
                this.loginCenterId = data.centerId; // 받은 데이터의 센터값 설정
                this.loginStaffId = data.centerStaffId; // 받은 데이터의 스태프 아이디 값 설정
                this.layerPasswordCode = true;
            } catch (error) {
                console.log(error);
            }
        },
        testMethod(event) {
            event.target.focus();
        },
        async firebaseEmailAuthSend(email,isCenterVerify) {
            try{
                await signInWithEmailAndPassword(getAuth(), email, '1234qwer')
                    .then(async (userCredential) => {
                        try {
                            await userCredential.user.delete(); // 무조건 등록 된 계정 삭제.
                        } catch {console.error}
                    })
            }catch {console.error}
            finally {
                createUserWithEmailAndPassword(getAuth(), email, '1234qwer')
                    .then(async (userCredential) => {
                        // Signed in
                        const user = userCredential.user;
                        console.log(user);

                        const actionCodeSettings = {
                            url: 'https://api.fittodayplus.com/admin/api/auth/success',
                            handleCodeInApp: false
                        };
                        sendEmailVerification(user,actionCodeSettings)
                        .then(() => {
                            console.error('sendSuccess');
                            this.tick = setInterval(() => {
                                console.log('reload...');
                                user.reload();

                                getAuth().onAuthStateChanged(user => {
                                console.warn('firebase onUserChanged call.');
                                // console.warn('res-->',user);
                                if(user.emailVerified){
                                    console.warn('이메일 인증 성공.');
                                    clearInterval(this.tick);
                                    if(isCenterVerify)
                                        this.layerCenterPassword = true; // 센터등록 패스워드창 띄우기
                                    else
                                        this.registCenterDlg.emailAuthNumber = '1' // 비번변경 이메일 인증 성공.
                                }
                            })
                            }, 1500);
                        })
                        .catch((error) => {
                            const errorCode = error.code;
                            const errorMessage = error.message;
                            console.error('2',errorCode,errorMessage);
                        });
                    })
                    .catch((error) => {
                        const errorCode = error.code;
                        const errorMessage = error.message;
                        console.error('1',errorCode,errorMessage);
                        // ..
                    });
            }

        },

        handleStaffAuth() {
            this.layerStaffAuth = true;
        },

        async onFindStaffAuth() {
            if (Utils.isEmpty(this.staffAuthDlg.name)) {
                alert('이름을 입력해 주세요.')
                return;
            }
            if (Utils.isEmpty(this.staffAuthDlg.phone)) {
                alert('핸드폰번호를 입력해 주세요.')
                return;
            }
            if (Utils.isEmpty(this.staffAuthDlg.email)) {
                alert('이메일을 입력해 주세요.')
                return;
            }

            try {
              const { data } = await this.findStaffAuthNumber();

              let msg = `${this.staffAuthDlg.name}님의 인증번호 입니다.`;
              data.forEach(staff => {
                    msg += `\n${staff.centerName}: ${staff.staffAuthNumber}`
                });
                alert(msg);

                this.registCenterDlg.email = this.staffAuthDlg.email
                this.registCenterDlg.staffAuthNumber = data[0].staffAuthNumber

                this.handleCancel("layerStaffAuth");
            } catch (error) {
                console.error(error);
                alert('입력하신 내용과 일치하는 정보를 찾을 수 없습니다. 다시 확인 후 시도해 주세요.');
            }
        },
        // API
        findStaffAuthNumber() {
            return api.post('/admin/api/auth/staff/staffAuthNumber', this.staffAuthDlg);
        },
    },
};
</script>

<style lang='scss' scoped>
.bottom-txt {
    text-align: center;
    margin-top: 24px;
    color: #999999;cursor: pointer;
}

.bottom-btn button:nth-child(1) {
    width: 45% !important;
}

.bottom-btn button:nth-child(2) {
    width: 45% !important;
    background: #1D73F2 !important;
}
</style>
